import { createActionCreator } from '../../lib/Actions';

const createAction = createActionCreator('ENTITY');

export const CREATE = createAction(
  'CREATE',
  ({ url, entity, ...context }) => ({ ...context, url, entity }),
);
export const DELETE = createAction(
  'DELETE',
  ({ url, id, ...context }) => ({ ...context, url, id }),
);
export const FETCH = createAction('FETCH', ({ url }) => ({ url }));
export const PATCH = createAction(
  'PATCH',
  ({ url, entity, ...context }) => ({ ...context, url, entity }),
);
export const PUT = createAction(
  'PUT',
  ({ url, entity, ...context }) => ({ ...context, url, entity }),
);
